const statuses = ['open', 'pending_customer', 'in_progress', 'resolved'];

export const ticketsList = Array.from({ length: 24 }, (_, i) => ({
  id: `tkt-${13000 + i}`,
  ticketNumber: `MH-${13000 + i}`,
  subject: `Support request ${i + 1}: integration help`,
  description: 'Customer reports calendar sync delays after tenant migration.',
  tenantId: `tnt-${5000 + (i % 15)}`,
  tenantCode: `MH-${String(5000 + (i % 15)).padStart(4, '0')}`,
  companyName: `Ticket Co ${i + 1}`,
  severity: ['low', 'medium', 'high', 'critical'][i % 4],
  priority: ['P4', 'P3', 'P2', 'P1'][i % 4],
  status: statuses[i % 4],
  assignee: i % 3 === 0 ? null : `agent${i % 5}@meetinghub.ai`,
  slaDeadline: new Date(Date.now() + (i % 5 === 0 ? -3600000 : 86400000)).toISOString(),
  createdAt: new Date(Date.now() - i * 7200000).toISOString(),
  comments: [
    { id: `c1-${i}`, author: 'system', body: 'Ticket created from portal.', at: new Date(Date.now() - i * 7200000).toISOString() },
  ],
  linkedAlerts: [{ id: `alt-${i}`, title: 'Webhook error rate' }],
  linkedJobs: [`job-${9000 + i}`, `job-${9001 + i}`],
}));

export const runbooksList = Array.from({ length: 14 }, (_, i) => {
  const cat = ['Microsoft', 'Google', 'WhatsApp', 'Jobs', 'Billing', 'Auth'][i % 6];
  return {
    id: `rb-${i}`,
    title: ['Webhook storm', 'DLQ drain', 'OAuth token refresh', 'Quota override', 'Tenant suspend', 'Invoice stuck', 'MFA lockout'][i % 7],
    category: cat,
    lastUpdated: new Date(Date.now() - i * 86400000 * 10).toISOString(),
    owner: `ops${i % 3}@meetinghub.ai`,
    draft: i % 9 === 0,
    usefulCount: 12 + i * 3,
    steps: [
      'Verify incident scope and affected tenants.',
      'Check connector health board for provider status.',
      'Apply mitigation from playbook section B.',
      'Notify customer success if SLA breached.',
    ],
    relatedLinks: [
      { label: 'Integrations', path: 'integrations' },
      { label: 'Jobs', path: 'jobs' },
    ],
  };
});

export function buildTenantDiagnostics(tenantId) {
  return {
    tenantId,
    integrationHealth: [
      { provider: 'microsoft', status: 'healthy' },
      { provider: 'google', status: 'degraded' },
      { provider: 'whatsapp', status: 'healthy' },
    ],
    failedJobs: Array.from({ length: 5 }, (_, i) => ({
      id: `job-${tenantId}-${i}`,
      queue: 'meeting-sync',
      failedAt: new Date(Date.now() - i * 7200000).toISOString(),
    })),
    lastBooking: new Date(Date.now() - 86400000 * 2).toISOString(),
    usersActive: 42,
    onboarding: [
      { key: 'domain', label: 'Verify domain', done: true },
      { key: 'integrations', label: 'Connect calendar', done: false },
      { key: 'users', label: 'Invite admins', done: true },
    ],
    supportActions: [
      { ts: new Date(Date.now() - 86400000).toISOString(), text: 'Support mode session by agent1@mh.ai' },
      { ts: new Date(Date.now() - 172800000).toISOString(), text: 'Retry job batch queued' },
    ],
  };
}
